export default {"src":"/_next/static/media/Bitter_small.e248a97b.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};